document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.combo-slide').forEach(function(combo) {
    setupCombo(combo);
  });

  function setupCombo(combo) {
    const comboId = combo.dataset.comboId;
    const desconto = parseFloat(combo.dataset.desconto) || 0;
    const produtoItems = combo.querySelectorAll('.buy-together__item');
    const totalElement = combo.querySelector('.price-total');
    const oldTotalElement = combo.querySelector('.old-total');
    const addToCartButton = combo.querySelector('.add-bundle-to-cart');
    const errorWrapper = combo.querySelector('.buy-together-form__error-message-wrapper');
    const errorMessage = combo.querySelector('.buy-together-form__error-message');
    
    let selectedVariants = [];
    let originalTotal = 0;

    initVariantRadios(combo);
    
    combo.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', function() {
        updateSelectedVariant(this);
        calculateTotal();
      });
    });
    
    combo.querySelectorAll('.buy-together__item .item').forEach(item => {
      const radio = item.querySelector('input[type="radio"]');
      const label = item.querySelector('label');
      
      if (radio && label) {
        item.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const fieldset = radio.closest('fieldset');
          if (fieldset) {
            fieldset.querySelectorAll('input[type="radio"]').forEach(r => {
              if (r !== radio) {
                r.checked = false;
              }
            });
          }
          
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          updateSelectedVariant(radio);
          calculateTotal();
        });
        
        label.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const fieldset = radio.closest('fieldset');
          if (fieldset) {
            fieldset.querySelectorAll('input[type="radio"]').forEach(r => {
              if (r !== radio) {
                r.checked = false;
              }
            });
          }
          
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          updateSelectedVariant(radio);
          calculateTotal();
        });
      }
    });

    if (addToCartButton) {
      addToCartButton.addEventListener('click', function(e) {
        e.preventDefault();
        addBundleToCart();
      });
    }

    function initVariantRadios(combo) {
      produtoItems.forEach(function(item, index) {
        const variantRadios = item.querySelector('variant-radios');
        const hiddenInput = item.querySelector('input[name="id"]');
        
        try {
          const productForm = item.querySelector('product-form');
          if (!productForm) return;

          const variantScript = productForm.querySelector('script');
          if (!variantScript || !variantScript.textContent) return;

          const variantData = JSON.parse(variantScript.textContent);
          selectedVariants[index] = getFirstAvailableVariant(variantData);

          if (hiddenInput && selectedVariants[index]) {
            hiddenInput.value = selectedVariants[index].id;
            hiddenInput.removeAttribute('disabled');
          }

          if (variantRadios) {
            const uniqueInput = item.querySelector('input.unique-variant');
            if (uniqueInput) {
              uniqueInput.checked = true;
            }
          }
        } catch (error) {
        }
      });
    }

    function getFirstAvailableVariant(variants) {
      if (!Array.isArray(variants) || variants.length === 0) return null;
      return variants.find(v => v && v.available) || variants[0];
    }

    function updateSelectedVariant(radio) {
      if (!radio) return;
      
      const itemContainer = radio.closest('.buy-together__item');
      if (!itemContainer) return;
      
      const index = parseInt(itemContainer.dataset.index);
      if (isNaN(index)) return;
      
      try {
        const productForm = itemContainer.querySelector('product-form');
        if (!productForm) return;

        const variantScript = productForm.querySelector('script');
        if (!variantScript || !variantScript.textContent) return;
        
        const variants = JSON.parse(variantScript.textContent);
        const options = {};

        itemContainer.querySelectorAll('.product-form__input input:checked').forEach(input => {
          const position = parseInt(input.dataset.position);
          if (!isNaN(position)) {
            options[position] = input.value;
          }
        });

        const variant = variants.find(v => {
          return Object.entries(options).every(([position, value]) => {
            return v[`option${position}`] === value;
          });
        });

        if (variant) {
          selectedVariants[index] = variant;
          
          const hiddenInput = itemContainer.querySelector('input[name="id"]');
          if (hiddenInput) {
            hiddenInput.value = variant.id;
            hiddenInput.removeAttribute('disabled');
          }
        }
      } catch (error) {
      }
    }

    function calculateTotal() {
      let totalCents = 0;
      let allAvailable = true;

      produtoItems.forEach(function(item, index) {
        if (selectedVariants[index]) {
          if (!selectedVariants[index].available) {
            allAvailable = false;
          }
          totalCents += selectedVariants[index].price;
        }
      });

      originalTotal = totalCents;
      
      let finalPrice = totalCents;
      
      if (desconto > 0) {
        finalPrice = Math.round(totalCents * ((100 - desconto) / 100));
        
        if (oldTotalElement) {
          oldTotalElement.textContent = formatPrice(originalTotal);
          oldTotalElement.classList.remove('hidden');
        }
      } else if (oldTotalElement) {
        oldTotalElement.classList.add('hidden');
      }

      finalTotal = finalPrice;

      if (totalElement) {
        totalElement.textContent = formatPrice(finalPrice);
        totalElement.dataset.totalCents = finalPrice;
        totalElement.dataset.total = (finalPrice / 100).toFixed(2);
      }

      if (addToCartButton) {
        addToCartButton.disabled = !allAvailable;
      }
    }

    function formatPrice(cents) {
      return (cents / 100).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      });
    }

    function addBundleToCart() {
      const unavailableItem = selectedVariants.find(v => !v || !v.available);
      if (unavailableItem) {
        showError('Um ou mais produtos não estão disponíveis');
        return;
      }

      if (addToCartButton) {
        addToCartButton.setAttribute('disabled', 'disabled');
        addToCartButton.classList.add('loading');
        addToCartButton.innerHTML = 'Adicionando...';
      }

      try {
        const items = [...selectedVariants]
          .filter(v => v && v.id)
          .reverse()
          .map(v => ({
            id: v.id,
            quantity: 1,
            properties: {
              _combo_id: comboId
            }
          }));
        
        if (!items.length) {
          showError('Nenhum produto selecionado');
          resetButton();
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(data => {
              throw new Error(data.description || 'Erro na resposta da rede');
            });
          }
          return response.json();
        })
        .then(data => {
          goToCart();
        })
        .catch(error => {
          showError(error.message || 'Erro ao adicionar produtos');
          resetButton();
        });
      } catch (error) {
        showError('Erro ao processar produtos');
        resetButton();
      }
    }

    function resetButton() {
      if (addToCartButton) {
        addToCartButton.removeAttribute('disabled');
        addToCartButton.classList.remove('loading');
        addToCartButton.innerHTML = 'Adicionar ao carrinho';
      }
    }

    function goToCart() {
      window.location.href = '/cart';
    }

    function showError(message) {
      if (errorWrapper && errorMessage) {
        errorMessage.textContent = message;
        errorWrapper.hidden = false;
        
        setTimeout(() => {
          errorWrapper.hidden = true;
        }, 5000);
      }
    }
  }
});

